import {
  REQUEST_MANIFEST,
  RECEIVE_MANIFEST,
  FAILED_MANIFEST
} from '../actions/manifest'

const initialState = {
  isFetching: false,
  items: []
}

export function subjects(state = initialState, action) {
  switch (action.type) {
    case REQUEST_MANIFEST: {
      return Object.assign({}, state, {
        isFetching: true,
        items: []
      })
    }
    case RECEIVE_MANIFEST: {
      const subjects = Object.assign({}, action.payload.manifest.subjects)
      const subjectsArray = []
      for (let i = 0; i < Object.keys(subjects).length; i++) {
        subjectsArray.push({
          id: parseInt(Object.keys(subjects)[i]),
          name: Object.values(subjects)[i]
        })
      }
      return Object.assign({}, state, {
        items: subjectsArray,
        isFetching: false
      })
    }
    case FAILED_MANIFEST: {
      return Object.assign({}, state, {
        isFetching: false,
        items: []
      })
    }
    default: {
      return state
    }
  }
}



// WEBPACK FOOTER //
// ./src/reducers/subjects.js